import React from 'react'
import { Link } from 'react-router-dom'

import styles from './defaultLink.module.scss'

const DefaultLink = props => {
  const { link } = props

  return (
    <Link className={styles.defaultLink} to={link}>{props.children}</Link>
  )
}

export default React.memo(DefaultLink)